import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {getRangeForZoom, orderData, configTooltip, createSeries, orderDataStackedBar, getObjectWithFull} from './functions';


class Configuration {
  constructor(chart, data, config) {
    this.data = data;
    this.chart = chart;
    this.config = config;
  }
  async horizontal_simple(){
    let config = this.config;
    if(this.config.ordering !== false){
      this.data = await orderData(this.data, this.config.configChart, this.config.ordering);
    }

    let info = await getObjectWithFull(this.data, this.config.configChart.value);
    this.data = info.data;
    let mayor = info.mayor;
    let rangeZoom = getRangeForZoom(this.data, this.config.configChart);

    let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = this.config.configChart.category;
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.tooltip.disabled = true;
    categoryAxis.renderer.fontSize = 12;
    if(categoryAxis.titles){
      categoryAxis.title.text = this.config.titles.yAxis;
    }
    
    let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.strokeOpacity = 0;
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 5;
    valueAxis.title.text = this.config.xAxis;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.renderer.fontSize = 10;
    valueAxis.min = 0;
    valueAxis.max = mayor + (mayor / 2);

    let series1 = this.chart.series.push(new am4charts[this.config.seriesType]);
    series1.dataFields.categoryY = this.config.configChart.category;
    series1.clustered = false;
    series1.dataFields.valueX = "full";
    series1.columns.template.fill =  am4core.color("#D4D4D4");
    series1.columns.template.fillOpacity = 1;
    series1.columns.template.strokeWidth = 0;

    let series = this.chart.series.push(new am4charts[this.config.seriesType]);
    series.dataFields.categoryY = this.config.configChart.category;
    series.dataFields.valueX = this.config.configChart.value;
    if(this.config.tooltip){
      series.tooltipText = this.config.tooltip.text;
      series = await configTooltip(series, this.config.tooltip);
    }
    
    if(this.config.colors && !Array.isArray(this.config.colors) && this.config.colors.min && this.config.colors.max){
      series.heatRules.push({
        target: series.columns.template,
        property: "fill",
        min: am4core.color(this.config.colors.min),
        max: am4core.color(this.config.colors.max),
        dataField: "valueX"
      })
    }
    
    if(this.config.colors && Array.isArray(this.config.colors)){
      let categoriesColor = {};
      let cont =  0;
      for(let i = 0; i <= this.config.colors.length - 1; i++){
        this.chart.colors.list.push(am4core.color(this.config.colors[i]));
      }
      series.columns.template.adapter.add("fill", function(fill, target) {
        if( !(target.dataItem.categoryY in categoriesColor)){
          let assingColor = am4core.color(config.colors[cont]);
          categoriesColor[target.dataItem.categoryY] = config.colors[cont];
          if(cont === config.colors.length - 1){
            cont = 0;
          }else{
            cont++;
          }
          return assingColor;
        }else{
          return am4core.color(categoriesColor[target.dataItem.categoryY]);
        }
      });
    }

    let columnTemplate = series.columns.template;
    columnTemplate.minWidth = 231
    columnTemplate.height = am4core.percent(70);
    columnTemplate.maxHeight = 50;
    columnTemplate.strokeOpacity = 0;
    columnTemplate.propertyFields.fillOpacity = "fillOpacity"
    columnTemplate.propertyFields.fill = "color"
    if(this.config.scrollingY){
      let scrollbarY = new am4core.Scrollbar();
      this.chart.scrollbarY = scrollbarY;
    }
    if(this.config.scrollingX){
      let scrollbarX = new am4core.Scrollbar();
      this.chart.scrollbarX = scrollbarX;
    }
    this.chart.cursor = new am4charts.XYCursor();
    this.chart.data = this.data;

      // Pre-zoom
    if(this.config.zoom){
      this.chart.events.on("ready", function () {
        categoryAxis.zoomToCategories(rangeZoom.min, rangeZoom.max);
      });
    }
    return this.chart;
    
  }

  async vertical_column_line_mix(){
    if(this.config.ordering !== false){
      this.data = await orderData(this.data, this.config.configChart, this.config.ordering);
    }
    
    let rangeZoom = getRangeForZoom(this.data, this.config.configChart);

    /* Create axes */
    let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = this.config.configChart.category;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.title.text = this.config.titles.xAxis;
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.fontSize = 12;

    let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = this.config.titles.yAxis;
    valueAxis.renderer.grid.template.strokeOpacity = 0;
    valueAxis.renderer.fontSize = 10;

    let columnSeries = this.chart.series.push(new am4charts.ColumnSeries());
    columnSeries.name = this.config.configChart.value1;
    columnSeries.dataFields.valueY = this.config.configChart.value1;
    columnSeries.dataFields.categoryX = this.config.configChart.category;
    if(this.config.colors && Array.isArray(this.config.colors)){
      columnSeries.fill = am4core.color(this.config.colors[0]);
      columnSeries.stroke = am4core.color(this.config.colors[0]);
    }else{
      columnSeries.fill = this.chart.colors.getIndex(0);
      columnSeries.stroke = this.chart.colors.getIndex(0);
    }
    if(this.config.tooltip){
      columnSeries.columns.template.tooltipText =  this.config.tooltip.text;
      columnSeries = await configTooltip(columnSeries, this.config.tooltip);
    }

    

    let lineSeries = this.chart.series.push(new am4charts.LineSeries());
    lineSeries.name = this.config.configChart.value2;
    lineSeries.dataFields.valueY = this.config.configChart.value2;
    lineSeries.dataFields.categoryX = this.config.configChart.category;

    lineSeries.stroke = am4core.color(this.config.colors[1]);
    lineSeries.strokeWidth = 4;
    lineSeries.propertyFields.strokeDasharray = "lineDash";
    lineSeries.tensionX = 0.7;

    let bullet = lineSeries.bullets.push(new am4charts.Bullet());
    if(this.config.colors && Array.isArray(this.config.colors)){
      bullet.fill = am4core.color(this.config.colors[1]);
    }else{
      bullet.fill = this.chart.colors.getIndex(1);
    }
    if(this.config.tooltip){
      bullet.tooltipText = this.config.tooltip.text
      lineSeries = await configTooltip(lineSeries, this.config.tooltip);
    }
    
    let circle = bullet.createChild(am4core.Circle);
    circle.radius = 2;
    circle.strokeWidth = 0;
    if(this.config.scrollingY){
      let scrollbarY = new am4core.Scrollbar();
      this.chart.scrollbarY = scrollbarY;
    }
    if(this.config.scrollingX){
      let scrollbarX = new am4core.Scrollbar();
      this.chart.scrollbarX = scrollbarX;
    }
    if(this.config.zoom){
      this.chart.events.on("ready", function () {
        categoryAxis.zoomToCategories(rangeZoom.min, rangeZoom.max);
      });
    }
    this.chart.data = this.data;
  }

  async both_scatter_chart(){
    let keys = Object.keys(this.data[0]);
    let orderSeries = [];
    for(let i = 0; i <= keys.length -1; i++){
      let split = keys[i].split('-');
      if ( !orderSeries.includes(split[0]) ){
        orderSeries.push(split[0]);
      }
    }    
    // Create axes
    let valueAxisX = this.chart.xAxes.push(new am4charts.ValueAxis());
    valueAxisX.title.text = this.config.titles.xAxis;
    valueAxisX.title.dy = 20;
    valueAxisX.renderer.minGridDistance = 40;
    valueAxisX.renderer.labels.template.disabled = true;

    // Create value axis
    let valueAxisY = this.chart.yAxes.push(new am4charts.ValueAxis());
    valueAxisY.title.text = this.config.titles.yAxis;
    valueAxisY.renderer.labels.template.disabled = true;
    valueAxisY.title.dx = -15;
    for( let x = 0; x <= orderSeries.length - 1; x++){
      // Create series
      let lineSeries = this.chart.series.push(new am4charts.LineSeries());
      lineSeries.name = orderSeries[x];
      lineSeries.dataFields.valueY = orderSeries[x]+"-y";
      lineSeries.dataFields.valueX = orderSeries[x]+"-x";
      lineSeries.strokeOpacity = 0;

      let bullet = lineSeries.bullets.push(new am4charts.Bullet());

      if(this.config.tooltip){
        bullet.tooltipText = this.config.tooltip.text;
        lineSeries = await configTooltip(lineSeries, this.config.tooltip);
      }

      let circle = bullet.createChild(am4core.Circle);
      circle.horizontalCenter = "middle";
      circle.verticalCenter = "middle";
      circle.strokeWidth = 0;
      if( this.config.colors && Array.isArray(this.config.colors  ) ){
        circle.fill = am4core.color(this.config.colors[x]);
      }else{
        circle.fill = this.chart.colors.getIndex(x)
      }
      
      circle.direction = "top";
      circle.width = 10;
      circle.height = 10;
    }

    //scrollbars
    if(this.config.scrollingY){
      let scrollbarY = new am4core.Scrollbar();
      this.chart.scrollbarY = scrollbarY;
    }
    if(this.config.scrollingX){
      let scrollbarX = new am4core.Scrollbar();
      this.chart.scrollbarX = scrollbarX;
    }
    this.chart.data = this.data;
  }

  async horizontal_stacked_bar(){
    let data = await orderDataStackedBar(this.data);
    this.data = data.ordered;
    this.config.configChart.category = data.category;
    let keys = data.allKeys;
    // this.chart.legend = new am4charts.Legend();
    // this.chart.legend.position = "right";

    // Create axes
    let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = this.config.configChart.category;
    categoryAxis.renderer.grid.template.opacity = 0;
    categoryAxis.renderer.fontSize = 12;
    if(this.config.titles.yAxis){
      categoryAxis.title.text = this.config.titles.yAxis
    }
    

    let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.grid.template.opacity = 0;
    valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
    valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
    valueAxis.renderer.ticks.template.length = 10;
    // valueAxis.renderer.line.strokeOpacity = 0.5;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.renderer.minGridDistance = 40;
    valueAxis.renderer.fontSize = 10;
    if(this.config.titles.xAxis){
      valueAxis.title.text = this.config.titles.xAxis;
    }
    valueAxis.renderer.labels.template.disabled = true;
    let cont = 0;
    for(let i=0; i<= keys.length - 1; i++){
      if(keys[i] !== this.config.configChart.category){
        await createSeries(this.chart, keys[i], this.config, cont);
        cont++;
        if(this.config.colors && this.config.colors.length - 1 < cont){
          cont = 0;
        }
      }
      
    }
    this.chart.data = this.data;
    return this.chart;
  }

  async horizontal_line(){
    let keys = Object.keys(this.data[0]);
    // Create category axis
    let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = this.config.configChart.category;
    categoryAxis.renderer.opposite = false;
    if(this.config.titles.xAxis){
      categoryAxis.title.text = this.config.titles.xAxis;
    }
    categoryAxis.renderer.fontSize = 15;

    // Create value axis
    let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.inversed = false;
    if(this.config.titles.yAxis){
      valueAxis.title.text = this.config.titles.yAxis;
    }
    
    valueAxis.renderer.minLabelPosition = 0.01;
    valueAxis.renderer.fontSize = 15;

    this.chart.cursor = new am4charts.XYCursor();
    // this.chart.cursor.behavior = "zoomY";

    // Add legend
    let legend = this.chart.legend = new am4charts.Legend();
    legend.position = "top"
    legend.contentAlign  = "right";
    legend.useDefaultMarker = true;
    legend.itemContainers.template.clickable = false;
    legend.itemContainers.template.focusable = false;
    legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default

    let cont = 0;
    for(let i = 0; i<= keys.length - 1; i++){
      if( keys[i] !== this.config.configChart.category){
        let series = this.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = keys[i];
        series.dataFields.categoryX = this.config.configChart.category;
        series.name = keys[i];
        series.strokeWidth = 2;
        let bullet = series.bullets.push(new am4charts.CircleBullet());
        series.tooltipText = "Place taken by {name} in {categoryX}: {valueY}";
        series.visible  = false;
        if(this.config.colors && Array.isArray(this.config.colors)){
          bullet.fill = am4core.color(this.config.colors[cont]);
          series.stroke = am4core.color(this.config.colors[cont]);
          series.fill = am4core.color(this.config.colors[cont]);
          cont++;
          if(this.config.colors.length - 1 < cont){
            cont = 0;
          }
        }
        
        series = await configTooltip(series, this.config.tooltip);
      }
    }

    // Add chart cursor
    
    this.chart.data = this.data;
    return this.chart;
  }
}


export default Configuration
